import { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from '../Components/Modal';
import BiddingForm from './BiddingForm';
import { BankAccountDetails } from './BankAccountDetails';
import { getToken, windowReload } from '../utils';
import PaymentOptions from './PaymentOptions';

function StageMakePayment({ content }) {
  const [disableButton, setDisableButton] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);

  const [input, setInput] = useState({ image: '' });
  const [file, setFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const userToken = getToken().token;
  const userId = getToken()?.user.id;

  const {
    getDataById,
    handleOpenandCloseModal,
    openModal,
    handleToast,
    clickedBidChatUser,
    trxoriginatorId,
    disablePayment,
  } = content;

  // const [messageDetails, setMessageDetails] = useState(
  //   getDataById?.payment_status?.name
  // );

  const messageDetails = getDataById?.payment_status?.name;

  const currencyId = getDataById?.base_currency?.id;
  const paymentId = paymentDetails?.id;
  const transationId = getDataById?.id;
  useEffect(() => {
    if (
      getDataById?.originator?.id === userId &&
      getDataById?.payment_status?.id === 3
    ) {
      setDisableButton(false);
    } else if (
      getDataById?.originator?.id !== userId &&
      getDataById?.transaction_status?.id === 5
    ) {
      setDisableButton(false);
    }
  }, [
    getDataById?.originator?.id,
    userId,
    getDataById?.payment_status?.id,
    getDataById?.transaction_status?.id,
  ]);

  const handleFileChange = (event) => {
    const files = event.target.files || event.dataTransfer?.files;
    setSelectedFiles([...files]);
  };

  const handleSubmitPayment = async () => {
    const formData = new FormData();
    selectedFiles.map((file) => formData.append('image[]', file));

    try {
      setIsSubmittingPayment(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/payments/proof?payment_id=${paymentId}&cx_transaction_id=${transationId}`,

        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${userToken}`,
            // 'Content-Type': 'multipart/form-data',
          },
          body: formData,
        }
      );
      const data = await response.json();
      // setMessageDetails(data?.transaction?.payment_status?.name);
      handleToast('success', `${data?.status}`);
      // setSelectedFiles([]);
      // setInput({ image: '' });
      // setFile(null);
      // setDisableButton(true);
      handleOpenandCloseModal('close');
      windowReload();
    } catch (error) {
      handleToast('error', 'Failed to submit, please try again!');
    } finally {
      setIsSubmittingPayment(false);
      setSelectedFiles([]);
    }
  };
  // Convert to Date object
const dateObj = new Date(getDataById?.payment?.deadline);

// Format the date
const formattedDate = dateObj.toLocaleDateString('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});
const formattedTime = dateObj.toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

  return (
    <div className='w-full pb-4 border-hf p-4 rounded-lg relative'>
      <div
        className={` w-fit h-fit px-3 py-1 absolute -top-4 left-1/2 transform -translate-x-1/2  drop-shadow-md rounded-full flex justify-center items-center ${
          getDataById?.payment_status?.id === 2 ||
          getDataById?.payment_status?.id === 4
            ? 'bg-b-mc text-p-wh'
            : getDataById?.transaction_status?.id === 5 ||
              getDataById?.transaction_status?.id === 7
            ? 'bg-orange-500 text-p-wh'
            : 'bg-p-wh'
        }`}
      >
        3
      </div>
      <div className='flex flex-row justify-between mt-2 mb-2'>
        <h2 className='font-semibold text-sm'>Make Payment</h2>
        <button
          className='py-1.5 bg-b-mc h-fit text-p-wh rounded text-xs w-16 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80'
          onClick={() => handleOpenandCloseModal('makePayment')}
          disabled={!disablePayment}
        >
          Pay
        </button>
      </div>
      <div className='text-xs flex flex-col text-p-bk'>
        <p className='pt-2 text'>Payment status: {messageDetails}</p>
        <p className='pt-2 text text-red-500'>{getDataById?.payment?.deadline ? `Note: Payment should be made on/before ${formattedDate} ${formattedTime}` : '' }</p>
      </div>
      <Modal open={openModal === 'makePayment'}>
        <PaymentOptions
          data={{
            currencyId,
            userToken,
            handleToast,
            handleOpenandCloseModal,
            cxBankAccount: clickedBidChatUser?.account,
            bidChatAccepted: clickedBidChatUser?.chats[0],
            viewData: getDataById,
            paymentDetails,
            setPaymentDetails,
            handleSubmitPayment,
            input,
            setInput,
            openModal,
            file,
            setFile,
            isSubmittingPayment,
            handleFileChange,
            selectedFiles,
          }}
        />
      </Modal>
    </div>
  );
}

export default StageMakePayment;
